module.exports = __webpack_public_path__ + "static/nrdc-9fc6ed8e536c2d0c7e5671629f3b3a7e.jpg";